import { httpClient } from '@/api/http';
import { Coupon } from '@/api/vendors';

export interface CreateCouponPayload {
  merchantId: number;
  title: string;
  description: string;
  discountLabel: string;
  image: string;
  pointsCost: number;
  totalCount: number;
  validTill: string;
  minAmount: number;
  discountType: string;
  discountValue: number;
}

export async function createCoupon(payload: CreateCouponPayload): Promise<Coupon> {
  const { data } = await httpClient.post<Coupon>('/coupons', payload);
  return data;
}
